module.exports = __webpack_public_path__ + "static/media/spock.d0799fe9.svg";